import React, { useEffect, useState } from "react";
import moment from "jalali-moment";
import { useNavigate } from "react-router-dom";
import { getReservationListByDate, getReservationNoteBook } from "../../api/routes";
import queryString from "../../components/queryString";
import { toast } from "react-toastify";
import Loading from "../../components/Loading";
import MDBox from "../../components/MDBox";
import { Card, Grid, Icon } from "@mui/material";
import MDTypography from "../../components/MDTypography";
import DashboardNavbar from "../../examples/Navbars/DashboardNavbar";
import MDButton from "../../components/MDButton";
import DatePicker from "@hassanmojab/react-modern-calendar-datepicker";
import NoteBookTable from "./NoteBookTable";

export default function NoteBookFullView(){
  const [loading, setLoading] = useState(false);
  const [reservationList, setReservationList] = useState([]);
  const [selectedDate, setSelectedDate] = useState({
    day: parseInt(moment().locale("fa").format("D")),
    month: parseInt(moment().locale("fa").format("M")),
    year: parseInt(moment().locale("fa").format("YYYY")),
  });
  const [reservationNoteBook, setReservationNoteBook] = useState([]);
  const navigate = useNavigate();
  const m = moment();
  const renderCustomInput = ({ ref }) => (
    <div ref={ref} style={{
      position: "relative",
    }}>
      <p style={{
        position: "absolute", fontSize: 16, top: "-25px",
        width: "100%",
        textAlign: "center",
      }}>
        {moment(`${selectedDate.year}${String(selectedDate.month).padStart(2, "0")}${String(selectedDate.day).padStart(2, "0")}`, "jYYYYjMMjDD").locale("fa").format("dddd")}
      </p>
      <input
        readOnly
        placeholder="تاریخ"
        value={`${selectedDate.year}/${selectedDate.month}/${selectedDate.day}`}
        style={{
          outline: "none", textAlign: "center",
          border: "1px solid #49a3f1",
          borderRadius: 100,
          color: "#495057",
          cursor: "pointer",
          height: "44.3px",
          boxShadow: "0 0.5rem 1rem rgba(73, 163, 241, 0.2)",
          width: "150px",
          fontFamily: "IRANSansX",
        }}
      />
    </div>
  );
  useEffect(() => {
    setLoading(true);
    const FORMATTED_DATE = `${selectedDate.year}${String(selectedDate.month).padStart(2, "0")}${String(selectedDate.day).padStart(2, "0")}`;
    const query = {
      isNoteBook: 1,
    };
    getReservationListByDate(queryString(query), FORMATTED_DATE, (isOk, data) => {
      if (!isOk) {
        setLoading(false);
        return toast.error(data.message);
      } else {
        return setReservationList(data.sort((a,b)=>a.startTime < b.startTime ? -1 : 1));
      }
    });
    let query2 = {
      date: FORMATTED_DATE,
      all: 1,
    };

    getReservationNoteBook(queryString(query2), (isOk, data) => {
      if (!isOk) {
        setLoading(false);
        return toast.error(data.message);
      } else {
        setLoading(false);
        return setReservationNoteBook(data.data);
      }
    });
  }, [selectedDate]);

  const onChangeDateWithArrow = (type) => {
    let NEW_DATE;
    const FORMATTED_DATE = `${selectedDate.year}${String(selectedDate.month).padStart(2, "0")}${String(selectedDate.day).padStart(2, "0")}`;

    if (type === "subtract") {
      NEW_DATE = moment(FORMATTED_DATE, "jYYYYjMMjDD").locale("fa").subtract(1, "d").format("jYYYYjMMjDD");
    } else NEW_DATE = moment(FORMATTED_DATE, "jYYYYjMMjDD").locale("fa").add(1, "d").format("jYYYYjMMjDD");
    setSelectedDate({
      day: parseInt(String(NEW_DATE).slice(6)),
      month: parseInt(String(NEW_DATE).slice(4, 6)),
      year: parseInt(String(NEW_DATE).slice(0, 4)),
    });
  };
  return(
    <>
      <Loading loading={loading} />
      <MDBox>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <div>
                <MDButton style={{ color: "white", width: 200, borderRadius: 20, margin: "1rem 1rem 0 0" }}
                          onClick={() => navigate("/reservationNotebook")}
                          variant="gradient"
                          color="primary">
                  بازگشت
                </MDButton>
                <MDBox pt={1} px={2} display="flex" justifyContent={"space-between"}>
                  <div style={{ marginLeft: 10, cursor: "pointer" }}>
                    <Icon fontSize="large"
                          onClick={() => onChangeDateWithArrow("subtract")}
                          style={{ color: "rgb(62, 205, 219)" }}>navigate_next</Icon>
                  </div>
                  <DatePicker
                    value={selectedDate}
                    onChange={setSelectedDate}
                    renderInput={renderCustomInput}
                    selectorStartingYear={Number(m?.locale("fa")?.format("YYYY"))}
                    selectorEndingYear={Number(m?.locale("fa")?.format("YYYY")) + 1}
                    shouldHighlightWeekends
                    locale="fa"
                    calendarPopperPosition={"bottom"}
                    colorPrimary="#0fbcf9"
                    colorPrimaryLight="rgba(75, 207, 250, 0.4)"
                  />
                  <Icon fontSize="large"
                        onClick={() => onChangeDateWithArrow("add")}
                        style={{ cursor: "pointer", color: "rgb(62, 205, 219)" }}>chevron_left</Icon>
                </MDBox>
              </div>

              <NoteBookTable reservationNoteBook={reservationNoteBook} setReservationNoteBook={setReservationNoteBook} selectedDate={selectedDate}
                             data={reservationList} tableHeight={"90vh"} />
            </Card>
          </Grid>
        </Grid>
      </MDBox>
    </>
  )
}
